var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-snackbar",
        {
          staticClass: "custom-snackbar",
          attrs: {
            color: _vm.popup.type,
            timeout: 3000,
            top: "top",
            bottom: false
          },
          model: {
            value: _vm.popup.visbile,
            callback: function($$v) {
              _vm.$set(_vm.popup, "visbile", $$v)
            },
            expression: "popup.visbile"
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.popup.text) + " "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", text: "" },
              on: {
                click: function($event) {
                  _vm.popup.visible = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      ),
      _c("div", { staticClass: "px-2 py-4" }, [
        _c(
          "div",
          { staticClass: "mb-6" },
          [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  { staticStyle: { "padding-left": "0px" } },
                  [
                    _c(
                      "div",
                      {
                        style: {
                          "border-radius": "4px",
                          position: "relative",
                          display: "inline-block",
                          "box-sizing": "border-box"
                        }
                      },
                      [
                        _c("input", {
                          style: {
                            width: "4.375rem",
                            height: "4.375rem",
                            "border-radius": "5px",
                            "background-color": "#eee",
                            "background-repeat": "no-repeat !important",
                            "background-size": "contain !important",
                            "background-position": "center !important",
                            "background-image":
                              _vm.setting.logo == "" || _vm.setting.logo == null
                                ? ""
                                : "url('" + _vm.setting.logo + "') !important",
                            overflow: "hidden",
                            "padding-left": "4.375rem",
                            "box-shadow": "0px 0px 3px 3px rgba(0,0,0,0.2)"
                          },
                          attrs: {
                            type: "file",
                            name: "file",
                            accept: "image/*"
                          },
                          on: {
                            change: function($event) {
                              return _vm.filesChange(
                                $event.target.name,
                                $event.target.files
                              )
                            }
                          }
                        })
                      ]
                    ),
                    _c(
                      "v-icon",
                      {
                        staticStyle: {
                          top: "20px",
                          left: "-57px",
                          padding: "1px",
                          "background-color": "#eee",
                          "border-radius": "3px",
                          opacity: "75%"
                        }
                      },
                      [_vm._v("mdi-camera")]
                    ),
                    _c(
                      "v-tooltip",
                      {
                        attrs: {
                          left: "",
                          "max-width": "207",
                          "max-height": "57"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-icon",
                                  _vm._g(
                                    {
                                      staticClass: "help-icon",
                                      staticStyle: {
                                        float: "right",
                                        position: "relative",
                                        top: "5px"
                                      }
                                    },
                                    on
                                  ),
                                  [_vm._v("mdi-help")]
                                )
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "Logo shown in the top-left corner of the login box"
                          )
                        ])
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "compact",
                        staticStyle: {
                          display: "inline-block",
                          "vertical-align": "top",
                          "margin-top": "5px",
                          width: "100px"
                        }
                      },
                      [
                        _vm._v(" Add Brand Logo "),
                        _c("br"),
                        _c(
                          "span",
                          {
                            staticClass: "small",
                            staticStyle: { color: "#999" }
                          },
                          [_vm._v(".JPEG, .PNG")]
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "span",
              { staticClass: "fs-14 fw-700 mb-3 compact" },
              [
                _vm._v(" Landing Page "),
                _c(
                  "v-tooltip",
                  {
                    attrs: { left: "", "max-width": "207", "max-height": "57" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-icon",
                              _vm._g(
                                {
                                  staticClass: "help-icon",
                                  staticStyle: { float: "right" }
                                },
                                on
                              ),
                              [_vm._v("mdi-help")]
                            )
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "Page user is shown after they complete the login process"
                      )
                    ])
                  ]
                )
              ],
              1
            ),
            _c(
              "v-text-field",
              {
                staticClass: "compact",
                attrs: { label: "URL", "single-line": "" },
                model: {
                  value: _vm.setting.landingUrl,
                  callback: function($$v) {
                    _vm.$set(_vm.setting, "landingUrl", $$v)
                  },
                  expression: "setting.landingUrl"
                }
              },
              [_vm._v(_vm._s(_vm.setting.landingUrl))]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "pb-12 mx-4 float-right" },
        [
          _c(
            "v-btn",
            {
              staticClass: "px-3",
              staticStyle: {
                "background-color": "#ecc94b !important",
                "letter-spacing": "normal",
                color: "#666"
              },
              attrs: { height: "32" },
              on: {
                click: function($event) {
                  return _vm.preview()
                }
              }
            },
            [
              _c("span", { staticClass: "fs-12 text-capitalize" }, [
                _vm._v("Page Preview")
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pb-12 mt-12" },
        [
          _c(
            "v-btn",
            {
              attrs: { width: "100%", height: "48", id: "submit" },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [_vm._v("Save")]
          )
        ],
        1
      ),
      _vm.nonPremium()
        ? _c(
            "div",
            {
              staticStyle: {
                border: "solid 1px red",
                "margin-left": "-5px",
                width: "100%",
                "background-color": "rgba(255,255,255,0.9)",
                display: "block",
                height: "400px",
                position: "absolute",
                top: "10px",
                "text-align": "center"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "block",
                    position: "relative",
                    top: "100px"
                  }
                },
                [
                  _c("img", { attrs: { src: require("img/locked.svg") } }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "block",
                        "font-weight": "bold",
                        "font-size": "22px"
                      }
                    },
                    [_vm._v("Premium Feature")]
                  ),
                  _c("span", [_vm._v("PAY TO UPGRADE")]),
                  _c(
                    "v-card",
                    {
                      staticClass: "upgrade-banner",
                      attrs: { height: "55px", width: "100%", color: "#f3f3f3" }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { staticClass: "upgrade-banner-text-col" },
                            [
                              _c("ul", { staticClass: "upgrade-banner-text" }, [
                                _c("li", [_vm._v("- Track your customers")]),
                                _c("li", [_vm._v("- Grow you business")])
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "upgrade-banner-cta-col" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "upgrade-banner-cta",
                                  staticStyle: { color: "white" },
                                  attrs: { color: "#214294" },
                                  on: {
                                    click: function($event) {
                                      return _vm.GoToPaymentPage()
                                    }
                                  }
                                },
                                [_vm._v("PAY TO UPGRADE")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-dialog",
                {
                  attrs: {
                    fullscreen: "",
                    "hide-overlay": "",
                    transition: "dialog-bottom-transition"
                  },
                  model: {
                    value: _vm.showPlans,
                    callback: function($$v) {
                      _vm.showPlans = $$v
                    },
                    expression: "showPlans"
                  }
                },
                [
                  _c("Plans", {
                    attrs: { location: _vm.selectedLocation, view: _vm.view },
                    on: {
                      close: function($event) {
                        _vm.showPlans = false
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }